const nameMap = {
  BREAK: 'Break',
  BOUNCE: 'Bounce',
  BOUNCE_EMA: 'Bounce EMA',
  BREAK_EMA: 'Break EMA',
  BREAK_CANDLE_TYPE: 'Break Candle Type',
  CANDLE_TRIGGER: 'Candle Trigger',
  CONVICTION_CANDLE: 'Conviction Candle',
  FLAG: 'Flag',
  ORB: 'ORB',
  CANDLE_PATTERN: 'Candle Pattern'

}
export function getSetupName(upperCaseName) {
  return nameMap[upperCaseName]
}